export default {
  containerId: 'chart_div',
  exchange: 'cme',
  country: '',
  lang: 'zh_cn', // 语言 zh_CN 中文，zh_TW 繁体，zh_EN 英文
  symbol: 'bidu',
  symbolType: 'stk', // 'stk'股票 'sop'期权 'fut'期货 'fop'期货期权
  digitOffset: 2,
  multiplier: 1,
  minStepInAxisY: '0.25',
  axisType: 'normal',
  showLocalTime: false, // 是否按照本地时间展示
  upColor: 'var(--red)',
  downColor: 'var(--green)',
  notUpDownColor: 'var(--default-font-color)',
  chartStyle: 'candle',
  trendLineWidth: 2,
  trendLineColor: '#0AB4FA',
  trendAreaColor: '#0AB4FB',
  fontSize: '12px',
  candleWidth: 5,
  candleScale: 1,
  candleCountPerGrid: 15,
  showPriceExtentTag: true,
  showCurPriceLine: true,
  curPriceLineColor: 'var(--red)',
  curPriceLineBgColor: 'var(--red)',
  curPriceLineStrokeColor: 'var(--red)',
  showTiTips: false,
  tiTipsBgColor: 'var(--ti-tips-bg-color)',
  tiTipsFontColor: 'var(--default-font-color)',
  showFloatTips: true,
  crossLineColor: 'var(--default-font-color)',
  floatTipsPanelColor: 'var(--chart-color)',
  floatTipsFontColor: 'var(--default-font-color)',
  floatTipsType: 'p',
  hideRightAxis: true,
  extPriceTipsColor: 'var(--active-color)',
  axisTipBgColor: '#DDDDDD',
  axisTipFontColor: '#000000',
  axisBgColor: 'var(--block)',
  axisGridColor: 'var(--axis-line-color)',
  axisFontColor: 'var(--default-font-color)',
  axisScalePst: { left: 'hide', right: 'out' },
  stiSettings: {
    items: [
      {
        name: 'vol',
        config: [
          { n: 5, color: '#C5A07E', width: '1', visible: false },
          { n: 10, color: '#367996', width: '1', visible: false },
          { n: 20, color: '#B14481', width: '1', visible: false }
        ]
      }
    ]
  },
  showTiSettings: false,
  showZoomOutIn: true,
  showJumpLatest: true,
  axisMargin: { left: 0, right: 74, top: 20, bottom: 24 },
  displayType: 'normal',
  axisHeightRate: [0.7, 0.3] // 指标区域高度比例
}
